import WishListApi from "../features/wishlist/api/WishListApi";
import AppConfig from "@/classes/AppConfig";
import axios from "axios";

let api = null;
let pendingController = null;
let wishlistApiInstance = null;

export default class SearchCTCPersonalizationApi {


  static get api() {
    if (!api) {
      api = axios.create({
        baseURL: AppConfig.AppConf?.PersonalizeSearch_api?.url,
        headers: {
          "Content-Type": "application/json",
          ApiKey: AppConfig.AppConf?.PersonalizeSearch_api?.key
        }
      });
    }
    return api;
  }

  static async search(payload,ApiConfig) {
    // Cancel any previous in-flight search request
    if (pendingController) {
      pendingController.abort();
    }
    pendingController = new AbortController();

	//Reusing Wishlist Token (instance cached — not recreated on every call)
    if (!wishlistApiInstance) {
      wishlistApiInstance = new WishListApi(ApiConfig?.wishlist?.api);
    }
    const token = await wishlistApiInstance.getBearerToken();
    if (!token) {
      throw new Error("No bearer token available for personalization search");
    }

    try {
      const { data } = await this.api.post(
        "/Search",
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
          signal: pendingController.signal
        }
      );
      pendingController = null;
      return data;
    } catch (err) {
      if (err?.response?.status === 403) {
        const freshToken = await wishlistApiInstance.getBearerToken(true);
        const { data } = await this.api.post(
          "/Search",
          payload,
          {
            headers: { Authorization: `Bearer ${freshToken}` },
            signal: pendingController.signal
          }
        );
        pendingController = null;
        return data;
      }
      throw err;
    }
  }
}
